import { render } from "./BlogEdit.vue?vue&type=template&id=f682860a"
import script from "./BlogEdit.vue?vue&type=script&lang=js"
export * from "./BlogEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__